export enum EMarketingReports {
  BudgetROI = "budget_roi",
  TopTenWebsiteSources = "top_ten_website_sources",
  VDPsByChannel = "vdps_by_channel",
  VDPROI = "vdp_roi",
  LeadROI = "lead_roi",
  InternalReporting = "internal_reporting",
}
